import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Title = styled.h1`
  color: ${COLORS.WHITE};
  font-weight: 500;
  font-size: ${calcRem(24)};
`;

export const FormWrapper = styled.div`
  display: grid;
  min-width: 500px;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 30px;

  ${mediaQuery.isMobile} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const SubTitle = styled.div`
  padding: 20px 0;
`;
export const SubTitle2 = styled.div`
  ${FLEX.FlexBetweenEnd}
  padding: 20px 0;
`;

export const FormItem = styled.div`
  padding-bottom: 20px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  gap: 10px;  
}
`;

export const AttachmentInputWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
